import {
  UPDATE_USER_STARTED,
  UPDATE_USER_COMPLETED,
  UPDATE_USER_FAILED,
  CLEAR_STATES
} from '@/store/types'

function getDefaultState () {
  return {
    loading: false,
    done: false,
    error: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    // Update user
    [UPDATE_USER_STARTED] (state) {
      state.loading = true
    },
    [UPDATE_USER_COMPLETED] (state) {
      state.loading = false
      state.done = true
      state.error = undefined
    },
    [UPDATE_USER_FAILED] (state, err) {
      state.loading = false
      state.error = err
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async update ({ commit, rootState: { client = undefined, management } }, user) {
      try {
        commit(UPDATE_USER_STARTED)
        const { id: userId } = management.userDetails.user
        const { displayName, username } = user
        const updatedUser = await client.managementClient.updateUserProfile(userId, {
          display_name: displayName,
          username: username
        })
        commit('management/userDetails/GET_USER_COMPLETED', updatedUser, { root: true })
        commit(UPDATE_USER_COMPLETED)
      } catch (err) {
        commit(UPDATE_USER_FAILED, err)
      }
    }
  }
}
